//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Index',
  components: {
    selectDepartment: function selectDepartment() {
      return import('@/components/form-common/select-department');
    },
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    }
  },
  props: {
    /* eslint-disable */
    value: [Array, Object],
    departType: {
      default: function _default() {
        return '';
      },
      type: String
    },
    member: Boolean,
    range: {
      default: function _default() {
        return [];
      },
      type: Array
    },
    disabled: Boolean,
    formCreateInject: Object
  },
  data: function data() {
    return {
      oaDepartmentShow: false,
      memberShow: false,
      memberList: [],
      activeMastart: this.value || []
    };
  },
  watch: {
    value: function value(n) {
      this.activeMastart = n || [];
    },
    range: function range(n) {
      this.rangePerson = n;
    },
    departType: function departType(n) {
      this.departTypes = n;
    }
  },
  methods: {
    cardTag: function cardTag(type, index) {
      if (type === 1) {
        this.activeMastart.splice(index, 1);
      }
    },
    changeMastart: function changeMastart(data) {
      var _this = this;
      var array = [];
      data.forEach(function (value) {
        array.push({
          id: value.id,
          name: value.name,
          is_mastart: value.is_mastart || 0
        });
      });
      this.$emit('input', array);
      setTimeout(function () {
        _this.formCreateInject.api.validateField(_this.formCreateInject.rule.field);
      }, 300);
    },
    // 选择成员回调
    getSelectList: function getSelectList(data) {
      var _this2 = this;
      var array = [];
      data.forEach(function (value) {
        array.push({
          id: value.value,
          name: value.name,
          avatar: value.avatar
        });
      });
      this.memberList = data;
      this.$emit('input', array);
      setTimeout(function () {
        _this2.formCreateInject.api.validateField(_this2.formCreateInject.rule.field);
      }, 300);
    }
  }
};